import styled from "styled-components";

export const BackgroundSettings = styled.div`
  background-image: url(${(props) => props.bgImage}); 
  background-color: ${(props) => props.bgColor };
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 25px;
`;